import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./css/MenuReg.css";
import "./css/BaseMenuReg.css";
import SideNav from "./SideNav";
import TopRootDiv from "./TopRootDiv";
import SherDineNav from "./SherDineNav";
import Editing1 from "./images/MenuReg/Editing1.png";
import remove from "./images/Inventory/delete.png";
import right from "./images/right-arrow.png";
import Redeye1 from "./images/Inventory/visible.png";
// import Editing1 from './images/MenuReg/Editing1.png'
// import Redeye1 from './images/MenuReg/Redeye1.png'
import Down from "./images/MenuReg/chevron-down1.png";
import Search from "./images/MenuReg/search1.png";
import Add1 from "./images/MenuReg/Add1.png";
import AddCombo from "./images/icons/AddCombo.png";
import noImage from "./images/icons/depositphotos_247872612-stock-illustration-no-image-available-icon-vector.jpg";
import Minus1 from "./images/icons/minu1.png";
import Delete from "./images/icons/delete.png";
import AddVarientModel from "./AddVarientModel";
import { faL } from "@fortawesome/free-solid-svg-icons";
import ModalImage from "./ModelImage";
import { ToastContainer, toast } from "react-toastify";
import { DBContext } from "./DBContext";
import axios from "axios";
import Select, { components } from "react-select";
import io from "socket.io-client";
import TaxGroup from "./TaxGroup";

function BaseMenuRegDesktop() {
	const api_base_url = process.env.REACT_APP_API_BASE_URL;

	const { customerCode, logginedDB, user_Id } = useContext(DBContext);

	const location = useLocation();

	const [Database, setDatabase] = useState(localStorage.getItem("DB"));
	const [imgCode, setImgCode] = useState(localStorage.getItem("imgCode"));
	const [company, setCompany] = useState(localStorage.getItem("Company"));
	const [loadingKitchen, setLoadingKitchen] = useState([]); // To track the loading state
	const [loadingSubKitchen, setLoadingSubKitchen] = useState([]);
	const [discountList, setDiscountList] = useState([]);
	const [search, setSearch] = useState("");
	// //(loadingKitchen);

	const [kitchens, setKitchens] = useState(false);
	const [loadingTable, setLoadingTable] = useState(true); // To track the loading state

	// const [menuDelivery]
	const [item, setItem] = useState(() => {
		if (
			location.state === "areaCancel" ||
			location.state === "tableCancel" ||
			location.state === "addonCancel" ||
			location.state === "CategoryCancel" ||
			location.state === "taxCancel"
		) {
			return false;
		} else return true;
	});

	// useEffect(() => {
	//     // Connect to the WebSocket server
	//     const socket = io(api_base_url);

	//     socket.on('updateCategory', () => {
	//         handleGetCategories();
	//     });

	//     socket.on('updateKitchen', () => {
	//         handleGetKitchen();
	//     });

	//     socket.on('updateDiscount', () => {
	//         handleGetDiscount();
	//     });

	//     return () => {
	//         socket.disconnect();
	//     };

	// }, [api_base_url, logginedDB]);

	const socketRef = useRef(null);

	//   useEffect(() => {
	//     if (!logginedDB) return; // if not logged in, skip

	//     // connect socket
	//     socketRef.current = io(api_base_url, {
	//       transports: ["websocket"], // faster than polling
	//     });

	//     // make sure old listeners are removed before adding new ones
	//     socketRef.current
	//       .off("updateCategory")
	//       .on("updateCategory", handleGetCategories());

	//     socketRef.current
	//       .off("updateKitchen")
	//       .on("updateKitchen", handleGetKitchen());

	//     socketRef.current
	//       .off("updateDiscount")
	//       .on("updateDiscount",  handleGetDiscount());

	//     // cleanup on unmount
	//     return () => {
	//       socketRef.current.disconnect();
	//     };
	//   }, [api_base_url, logginedDB]);

	useEffect(() => {
		if (!logginedDB) return;

		// Run initial fetch
		handleGetCategories?.();
		handleGetKitchen?.();
		handleGetDiscount?.();

		socketRef.current = io(api_base_url, {
			transports: ["websocket"],
		});

		// Event listeners
		const handleCategoryEvent = () => {
			if (typeof handleGetCategories === "function") {
				handleGetCategories();
			}
		};

		const handleKitchenEvent = () => {
			if (typeof handleGetKitchen === "function") {
				handleGetKitchen();
			}
		};

		const handleDiscountEvent = () => {
			if (typeof handleGetDiscount === "function") {
				handleGetDiscount();
			}
		};

		socketRef.current.on("connect", () => {
			console.log("Connected to server");
		});

		socketRef.current.on("disconnect", () => {
			console.log("Disconnected from server");
		});

		socketRef.current.on("connect_error", (error) => {
			console.error("Connection error:", error);
		});

		// socketRef.current.on("createdCategory", handleCategoryEvent);
		socketRef.current.on("updateKitchen", handleKitchenEvent);
		socketRef.current.on("updateDiscount", handleDiscountEvent);

		return () => {
			if (socketRef.current) {
				// socketRef.current.off("createdCategory", handleCategoryEvent);
				socketRef.current.off("updateKitchen", handleKitchenEvent);
				socketRef.current.off("updateDiscount", handleDiscountEvent);
				socketRef.current.disconnect();
			}
		};
	}, [api_base_url, logginedDB]);

	const [category, setCategory] = useState(false);
	const [varients, setVarients] = useState(false);
	const [tableArea, setTableArea] = useState(false);
	const [addons, setAddons] = useState(false);
	const [addonsData, setAddonsData] = useState([]);
	const [taxes, setTaxes] = useState(false);
	const [discount, setDiscount] = useState(false);
	const [kitchen, setKitchen] = useState(false);
	const [CategoryDbData, setCategoryDbData] = useState([]);
	const [captain, setcaptain] = useState(false);

	const handleGetCategories = async () => {
		try {
			const response = await axios.get(
				`${api_base_url}/GetCategories/${logginedDB}`
			);
			if (response.status == 200) {
				setCategoryDbData(response.data.data);
			}
		} catch (error) {
			console.error("Error fetching Category:", error);
		}
	};

	const filtertCategory = CategoryDbData.filter((item) =>
		item?.Category_Name.toLowerCase().includes(search.toLowerCase())
	);

	const handleGetKitchen = async () => {
		try {
			const response = await axios.get(
				`${api_base_url}/GetKitchen/${logginedDB}`
			);
			if (response.status == 200) {
				setLoadingKitchen(response.data);
			}
		} catch (error) {
			//(error);
		}
	};

	const handleGetDiscount = async () => {
		try {
			const response = await axios.get(
				`${api_base_url}/GetDiscount/${logginedDB}`
			);
			if (response.status == 200) {
				setDiscountList(response.data);
			}
		} catch (error) {
			//(error);
		}
	};


	const filterDiscount = discountList.filter((item) =>
		item?.d_name.toLowerCase().includes(search.toLowerCase())
	);

	const handleGetSubKitchen = async () => {
		try {
			const response = await axios.get(
				`${api_base_url}/GetSubKitchen/${logginedDB}`
			);
			if (response.status == 200) {
				setLoadingSubKitchen(response.data);
			}
		} catch (error) {
			//(error);
		}
	};

	const handleKitcheanSearch = () => {
		const searchKitchen = loadingKitchen.filter(
			(val) =>
				val.KitchenName.toLowerCase().includes(search.toLowerCase()) ||
				val.KitchenCode.toLowerCase().includes(search.toLowerCase())
		);
		setLoadingKitchen(searchKitchen);
	};

	const handleShowKitchen = () => {
		handleGetKitchen();
		setSearch("");
	};

	const handleSubKitcheanSearch = () => {
		const searchKitchen = loadingSubKitchen.filter(
			(val) =>
				val.SubKitchenName.toLowerCase().includes(search.toLowerCase()) ||
				val.KitchenCode.toLowerCase().includes(search.toLowerCase())
		);
		setLoadingSubKitchen(searchKitchen);
	};

	const handleShowSubKitchen = () => {
		handleGetSubKitchen();
		setSearch("");
	};

	const handleGetAddons = async () => {
		try {
			const response = await axios.get(
				`${api_base_url}/GetAddons/${logginedDB}`
			);
			if (response.status == 200) {
				setAddonsData(response.data);
				//(response.data);
			}
		} catch (error) {
			//(error);
		}
	};

	const filteterAdon = addonsData.filter((item) =>
		item?.addon_name?.toLowerCase().includes(search.toLowerCase())
	);



	useEffect(() => {
		if (logginedDB) {
			handleGetKitchen();
			handleGetSubKitchen();
			handleGetCategories();
			handleGetAddons();
			handleGetDiscount();
		}
	}, [api_base_url, logginedDB]);

	// //(loadingKitchen, CategoryDbData, "hyjk");

	// useEffect(() => {
	//     // Fetch categories from the backend
	//     fetch(`${api_base_url}/GetTable/${Database}`)
	//         // .then((response) => response.json())
	//         .then((response) => {
	//             if (!response.ok) {
	//                 throw new Error('Network response was not ok');
	//             }
	//             return response.json();
	//         })
	//         .then((TableData) => {
	//             if (TableData.length === 0) {
	//                 //("error Table then if");
	//                 //(Database);

	//                 toast.error("No Table found.");
	//                 setLoadingTable([{ value: '', label: 'No Data' }]);
	//             } else {
	//                 //(" Table catch");
	//                 setLoadingTable(TableData.map((Table) => ({
	//                     value: Table.Table_id,
	//                     label: Table.Table_num
	//                 })))
	//                 setLoadingTable(TableData); // Store full data in the state
	//             }
	//         })
	//         .catch((error) => {
	//             //("error Table catch");
	//             console.error("Error fetching Table:", error)
	//             toast.error("Something went wrong while fetching Table Data.",
	//                 {
	//                     className: 'custom-toast',
	//                     bodyClassName: 'custom-toast-container',
	//                     closeButtonClassName: 'custom-toast-close-button',
	//                     onClose: () => { }
	//                 });
	//             setLoadingTable([{ value: '', label: 'No Table Data' }]); // Show "No Data" in the dropdown on error
	//         })
	//     // .finally(() => {
	//     //     setLoadingKitchen(false); // Set loading to false when fetch is complete
	//     // });
	// }, [api_base_url, Database]);
	// //(
	// loadingKitchen, CategoryDbData,
	// loadingTable, "hyjk");

	const toItem = () => {
		setItem(true);
		setCategory(false);
		setVarients(false);
		setAddons(false);
		setTableArea(false);
		setTaxes(false);
		setDiscount(false);
		setKitchens(false);
		setcaptain(false);
	};
	const toCategory = () => {
		setCategory(true);
		setCategoryParent(false);
		setCategoryCategory(true);
		setItem(false);
		setVarients(false);
		setAddons(false);
		setTableArea(false);
		setTaxes(false);
		setDiscount(false);
		setKitchens(false);
		setcaptain(false);
	};
	const toAddons = () => {
		setAddons(true);
		setTableArea(false);
		setTaxes(false);
		setCategory(false);
		setItem(false);
		setVarients(false);
		setDiscount(false);
		setKitchens(false);
		setcaptain(false);
	};
	const toTable_Area = () => {
		setTableArea(true);
		setTableArea_Tables(false);
		setTableArea_Areas(true);
		setTaxes(false);
		setCategory(false);
		setItem(false);
		setVarients(false);
		setAddons(false);
		setDiscount(false);
		setKitchens(false);
		setcaptain(false);
	};
	const toTaxes = () => {
		setTaxes(true);
		setCategory(false);
		setItem(false);
		setVarients(false);
		setAddons(false);
		setTableArea(false);
		setDiscount(false);
		setKitchens(false);
		setcaptain(false);
	};
	const toDiscount = () => {
		setKitchens(false);
		setDiscount(true);
		setTaxes(false);
		setCategory(false);
		setItem(false);
		setVarients(false);
		setAddons(false);
		setTableArea(false);
		setcaptain(false);
	};
	const toKitchen = () => {
		setKitchens(true);
		setKitchenTab(true);
		setSubKitchenTab(false);
		setcaptain(false);
		setDiscount(false);
		setTaxes(false);
		setCategory(false);
		setItem(false);
		setVarients(false);
		setAddons(false);
		setTableArea(false);
	};

	const [categoryParent, setCategoryParent] = useState(false);
	const [categoryCategory, setCategoryCategory] = useState(false);
	const [categoryGrouping, setCategoryGrouping] = useState(false);
	const [categoryMenu, setCategoryMenu] = useState(false);
	const toCategoryParent = () => {
		setCategoryParent(true);
		setCategoryCategory(false);
		setCategoryGrouping(false);
		setCategoryMenu(false);
	};
	const toCategoryCategory = () => {
		setCategoryCategory(true);
		setCategoryGrouping(false);
		setCategoryMenu(false);
		setCategoryParent(false);
	};
	const toCategoryGrouping = () => {
		setCategoryGrouping(true);
		setCategoryMenu(false);
		setCategoryParent(false);
		setCategoryCategory(false);
	};
	const toCategoryMenu = () => {
		setCategoryMenu(true);
		setCategoryParent(false);
		setCategoryCategory(false);
		setCategoryGrouping(false);
	};

	const [tableArea_Tables, setTableArea_Tables] = useState(false);
	const [tableArea_Areas, setTableArea_Areas] = useState(false);
	const toTableArea_Tables = () => {
		if (areaInfo.length > 0) {
			setTableArea_Tables(true);
			setTableArea_Areas(false);
		} else {
			toast.error(`Area not registered!`, {
				className: "custom-toast",
				bodyClassName: "custom-toast-container",
				closeButtonClassName: "custom-toast-close-button",
				onClose: () => { },
			});
		}
	};
	const toTableArea_Areas = () => {
		setTableArea_Areas(true);
		setTableArea_Tables(false);
	};

	const [KitchenTab, setKitchenTab] = useState(false);
	const [SubKitchenTab, setSubKitchenTab] = useState(false);
	const toKitchenTab = () => {
		setKitchenTab(true);
		setSubKitchenTab(false);
	};
	const toSubKitchenTab = () => {
		if (loadingKitchen.length > 0) {
			setSubKitchenTab(true);
			setKitchenTab(false);
		} else {
			toast.error(`Kitchen not registered!`, {
				className: "custom-toast",
				bodyClassName: "custom-toast-container",
				closeButtonClassName: "custom-toast-close-button",
				onClose: () => { },
			});
		}
	};

	const navigate = useNavigate();

	useEffect(() => {
		// Process location.state only on initial mount
		if (location.state === "areaCancel") {
			setTableArea(true);
			setTableArea_Areas(true);
			navigate(location.pathname, { replace: true, state: {} });
		} else if (location.state === "tableCancel") {
			setTableArea(true);
			setTableArea_Tables(true);
			navigate(location.pathname, { replace: true, state: {} });
		} else if (location.state === "addonCancel") {
			setAddons(true);
			navigate(location.pathname, { replace: true, state: {} });
		} else if (location.state === "KitchenCancel") {
			setItem(false);
			setKitchens(true);
			setKitchenTab(true);
			navigate(location.pathname, { replace: true, state: {} });
		} else if (location.state === "SubKitchenCancel") {
			setItem(false);
			setKitchens(true);
			setSubKitchenTab(true);
			navigate(location.pathname, { replace: true, state: {} });
		} else if (location.state === "CategoryCancel") {
			setItem(false);
			setCategory(true);
			setCategoryParent(false);
			setCategoryCategory(true);
			handleGetCategories();
			navigate(location.pathname, { replace: true, state: {} });
		} else if (location.state === "taxCancel") {
			setItem(false);
			setTaxes(true);
			navigate(location.pathname, { replace: true, state: {} });
		} else if (location.state === "DiscountCancel") {
			setItem(false);
			setDiscount(true);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, []);

	const toAddArea = () => {
		navigate("/tableareareg");
	};
	const toAddTable = () => {
		navigate("/tablereg");
	};
	const toAddCate = () => {
		navigate("/categoryreg");
	};
	const toAddItem = () => {
		navigate("/additem", {
			state: null,
		});
	};

	const toAddAddon = () => {
		navigate("/AddonReg");
	};

	const toAddCaptain = () => {
		navigate("/CaptainReg");
	};

	// const [addVarient,setAddVarient] = useState(false)
	// const toAddVarient = () => {
	//     setAddVarient(true)
	// }

	const fileInputRef = useRef(null); // Ref for accessing file input element
	const [image, setImage] = useState(null);
	const [preview, setPreview] = useState(null);
	const [loading, setLoading] = useState(false); // State to track loading indicator

	const handleUploadImg = () => {
		// Click the hidden file input element
		return fileInputRef.current.click();
	};

	const handleImageChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			setLoading(true); // Set loading to true when starting to load
			setImage(file);
			const reader = new FileReader();
			reader.onloadend = () => {
				setLoading(false); // Set loading to false when finished loading
				setPreview(reader.result);
			};
			reader.readAsDataURL(file);
		}
	};

	const toModifyItem = (root, id) => {
		if (root === "item") {
			navigate("/AddItem", {
				state: id,
			});
		} else if (root === "categoryCategory") {
			navigate("/categoryreg");
		} else if (root === "addon") {
			navigate("/EditAddon", {
				state: "toEdit",
			});
		} else if (root === "area") {
			navigate("/tableareareg");
		} else if (root === "Kitchen") {
			navigate("/Kitchen");
		}
	};

	const toDeleteItem = async (itemId) => {
		const isConfirmed = window.confirm(
			"Are you sure you want to delete this item?"
		);

		if (isConfirmed) {
			// try {
			//     const response = await fetch(`${api_base_url}/deleteItem/${itemId}`, {
			//         method: 'DELETE',
			//         headers: {
			//             'Content-Type': 'application/json',
			//         },
			//     });
			//     if (response.ok) {
			//         alert("Item deleted successfully.");
			//         // Refresh the items list or remove the item from the state
			//         setItems(prevItems => prevItems.filter(item => item.id !== itemId));
			//     } else {
			//         alert("Failed to delete the item.");
			//     }
			// } catch (error) {
			//     console.error('Error deleting item:', error);
			//     alert("An error occurred while deleting the item.");
			// }
		}
	};

	const parentRef = useRef(null);

	const [checkBoxSelectAll, setCheckBoxSelectAll] = useState(false);
	const handleCheckBoxSelectAll = (e) => {
		// //(e.target.checked);
		setCheckBoxSelectAll(e.target.checked);
		if (!checkBoxSelectAll) {
			setCheckBoxSelect(!checkBoxSelect);
		}
	};
	const [checkBoxSelect, setCheckBoxSelect] = useState(false);
	const handleCheckBoxSelect = (e) => {
		setCheckBoxSelect(e.target.checked);
		// //(e.target.checked);
		if (checkBoxSelectAll & (e.target.checked === false)) {
			setCheckBoxSelect(false);
			// //("");
		}
	};

	const [items, setItems] = useState([]);

	//('items',items);

	const [modalImage, setModalImage] = useState(null);

	// //('customerCode',customerCode);

	const handleGetItems = async () => {
		if (!customerCode) return;

		try {
			const response = await fetch(
				`${api_base_url}/getItem/${logginedDB}/${customerCode}`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					},
				}
			);
			const data = await response.json();
			if (data.success) {
				setItems(data.data);
				// //('data.data',data.data);
			}
		} catch (error) {
			console.error("Error fetching items:", error);
		}
	};

	const filteterItem = items.filter(
		(item) =>
			item?.productName.toLowerCase().includes(search.toLowerCase()) ||
			item?.itemCode.toLowerCase().includes(search.toLowerCase())
	);

	//   console.log(filteterItem, "filter 34567890-");


	useEffect(() => {
		if (customerCode) {
			handleGetItems();
		}
	}, [api_base_url, customerCode]);

	const [areaInfo, setAreaInfo] = useState([]);

	const [options, setOptions] = useState([]);

	const [selectedOption, setSelectedOption] = useState(null);

	const handleChange = (option) => {
		setSelectedOption(option);
	};

	const customStyles = {
		option: (provided, state) => ({
			...provided,
			fontSize: ".9em",
			// fontFamily: 'Poppins',
			textAlign: "left",
			backgroundColor: state.isSelected ? "#c8cbcf" : "#FFF",
			color: state.isFocused ? "#000" : "#000",
			cursor: "pointer", // Add cursor pointer on hover
			":hover": {
				backgroundColor: "#c8cbcf",
				color: "#000",
			},
			":active": {
				...provided[":active"],
				backgroundColor: "#c8cbcf",
			},
		}),
		control: (provided, state) => ({
			...provided,
			width: "100%",
			// height: '2.5rem',
			minHeight: "2rem",
			fontSize: "1em",
			borderRadius: selectedOption ? "0rem" : ".313rem", // Adjust this value as needed
			padding: "0", // Ensure no extra padding is added
			// border: 'none',
			fontWeight: "500",
			// color: 'white !important', // Set text color to white
			backgroundColor: "transparent", // Change this to 'transparent' for a clear background
			boxShadow: "none", // Remove the blue focus shadow
			border: selectedOption ? "none" : "1px solid #ccc", // Optional: add custom border on focus
			borderBottom: selectedOption ? "1px solid #ccc" : "1px solid #ccc",
			"&:hover": {
				borderBottom: "1px solid #c8cbcf", // Optional: border on hover
			},
			// border: state.selectValue ? '1px solid #ccc' : 'none', // Apply full border if no selected option
			// borderBottom: state.selectValue ? '2px solid #c8cbcf' : '1px solid #ccc', // Apply bottom border when option is selected
			// '&:hover': {
			// 	border: state.selectValue ? '1px solid #ccc' : 'none', // Apply full border on hover if no option selected
			// 	borderBottom: state.selectValue ? '2px solid #c8cbcf' : 'none', // Apply bottom border on hover
			// }
		}),
		valueContainer: (provided) => ({
			...provided,
			height: "2.25rem",
			minHeight: "2rem",
			padding: "0 8px", // Center the text vertically
			display: "flex",
			//   color: '#fff',
			alignItems: "center",
			fontSize: ".9rem",
		}),
		input: (provided) => ({
			...provided,
			height: "2.25rem",
			minHeight: "2rem",
			margin: "0",
			padding: "0",
			//   color: '#fff',
			fontSize: ".9rem",
		}),
		indicatorsContainer: (provided) => ({
			...provided,
			height: "2.25rem",
			display: "flex",
			alignItems: "center",
			padding: ".5rem",
			paddingTop: "0",
			paddingBottom: "0",
		}),
		dropdownIndicator: (provided) => ({
			...provided,
			padding: "0", // Remove padding to center the icon
			width: "1rem",
			marginLeft: ".5rem",
			//   color: '#fff',
			cursor: "pointer",
		}),
		placeholder: (provided) => ({
			...provided,
			margin: "0",
			fontSize: "1em",
			//   color: '#fff',
			//   fontFamily: 'poppins'
		}),
		menu: (provided) => ({
			...provided,
			//   borderRadius: '.1rem', // Adjust this value as needed
		}),
		singleValue: (provided) => ({
			...provided,
			// color: 'white', // Set selected option text color to white
		}),
	};

	// //(areaInfo);
	const [tables, setTables] = useState([]);

	const handleGetTables = async () => {
		try {
			const response = await axios.get(
				`${api_base_url}/GetTable/${selectedOption.value}/${logginedDB}`
			);
			if (response.status == 200) {
				setTables(response.data);
			}
		} catch (error) {
			//(error);
		}
	};

	useEffect(() => {
		if (selectedOption) {
			handleGetTables();
		}
	}, [selectedOption]);

	const [areaTableLabels, setAreaTableLabels] = useState([]);
	// //(areaTableLabels);
	useEffect(() => {
		fetchData();
	}, [tableArea_Areas, tableArea_Tables]);

	const fetchData = async () => {
		try {
			const response = await fetch(`${api_base_url}/getAreaInfo/${logginedDB}`);
			if (!response.ok) {
				throw new Error("Failed to fetch data");
			}
			const data = await response.json();
			// //(data);

			// // Process data to add tableLabels based on area.Tables
			// const processedData = data.map((area) => ({
			//     ...area,
			//     tableLabels: Array.from({ length: area.Tables }, (_, index) => `${area.AreaCode}${index + 1}`)
			// }));

			// // Extract tableLabels into a separate state
			// const labels = processedData.map((area) => area.tableLabels).flat(); // Flatten to get a single array
			// setAreaTableLabels(labels);

			const transformedData = data.map((area) => ({
				value: area.Area_id,
				label: area.AreaName,
			}));

			setOptions(transformedData);

			setAreaInfo(data);
		} catch (error) {
			console.error("Error fetching data:", error);
			// Handle error state, set fallback data, or display an error message
		}
	};

	const handleImageClick = (imageUrl) => {
		if (items) {
			setModalImage(imageUrl);
		}
		// //(items);
	};

	const closeModal = () => {
		setModalImage(null);
	};

	const [sideNav, setSideNav] = useState(false);
	const handleSideNav = (state) => {
		setSideNav(state);
	};
	const [falseState, setFalseState] = useState(null);

	const [isActive, setIsActive] = useState(false);
	const [isActiveTable, setIsActiveTable] = useState(false);
	const [isActiveKitchen, setIsActiveKitchen] = useState(false);
	const [isActiveSubKitchen, setIsActiveSubKitchen] = useState(false);
	const [isActiveCategory, setIsActiveCategory] = useState(false);
	const [isActiveAddon, setIsActiveAddon] = useState(false);
	const [isActiveDiscount, setIsActiveDiscount] = useState(false);

	useEffect(() => {
		if (areaInfo) {
			// Initialize `isActive` state based on `areaInfo` when it changes
			const activeStates = areaInfo.reduce((acc, area) => {
				acc[area.Area_id] = area.Status === 1;
				return acc;
			}, {});
			setIsActive(activeStates);
		}
		if (tables) {
			// Initialize `isActive` state based on `areaInfo` when it changes
			const activeStates = tables.reduce((acc, table) => {
				acc[table.Table_id] = table.Status === 1;
				return acc;
			}, {});
			setIsActiveTable(activeStates);
		}
		if (loadingKitchen) {
			// /Initialize `isActive` state based on `areaInfo` when it changes
			const activeStates = loadingKitchen.reduce((acc, kitchen) => {
				acc[kitchen.Kitchen_id] = kitchen.Kitchen_is_Active === 1;
				return acc;
			}, {});
			setIsActiveKitchen(activeStates);
		}
		if (loadingSubKitchen) {
			// Initialize `isActive` state based on `areaInfo` when it changes
			const activeStates = loadingSubKitchen.reduce((acc, kitchen) => {
				acc[kitchen.Sub_Kitchen_id] = kitchen.Sub_Kitchen_is_Active === 1;
				return acc;
			}, {});
			setIsActiveSubKitchen(activeStates);
		}
		if (CategoryDbData) {
			// Initialize `isActive` state based on `areaInfo` when it changes
			const activeStates = CategoryDbData.reduce((acc, category) => {
				acc[category.id_category] = category.Status === 1;
				return acc;
			}, {});
			setIsActiveCategory(activeStates);
		}
		if (addons) {
			// Initialize `isActive` state based on `areaInfo` when it changes
			const activeStates = addonsData.reduce((acc, addon) => {
				acc[addon.id_addon] = addon.Status === 1;
				return acc;
			}, {});
			setIsActiveAddon(activeStates);
		}
		if (discount) {
			// Initialize `isActive` state based on `areaInfo` when it changes
			const activeStates = discountList.reduce((acc, disc) => {
				acc[disc.id_Discount] = disc.d_activeAllTime === 1;
				return acc;
			}, {});
			setIsActiveDiscount(activeStates);
		}
	}, [
		areaInfo,
		tables,
		loadingKitchen,
		loadingSubKitchen,
		CategoryDbData,
		addons,
		discount,
	]);

	// Function to handle active/inactive toggle
	const handleIsActive = async (id, currentStatus) => {
		// Update the `isActive` state immediately
		setIsActive((prev) => ({
			...prev,
			[id]: !prev[id],
		}));

		try {
			// Make API request to update status
			const response = await axios.post(
				`${api_base_url}/updateAreaActive/${id}/${currentStatus === 1 ? 0 : 1
				}/${logginedDB}`
			);

			if (response.status === 200) {
				fetchData();
			}
		} catch (error) {
			console.error("Error updating user status:", error);

			// Revert the change in case of an error
			setIsActive((prev) => ({
				...prev,
				[id]: currentStatus === 1,
			}));
		}
	};

	const handleIsActiveTable = async (id, currentStatus) => {
		// Update the `isActive` state immediately
		setIsActiveTable((prev) => ({
			...prev,
			[id]: !prev[id],
		}));

		try {
			// Make API request to update status
			const response = await axios.post(
				`${api_base_url}/updateTableActive/${id}/${currentStatus === 1 ? 0 : 1
				}/${logginedDB}`
			);

			if (response.status === 200) {
				handleGetTables();
			}
		} catch (error) {
			console.error("Error updating user status:", error);

			// Revert the change in case of an error
			setIsActiveTable((prev) => ({
				...prev,
				[id]: currentStatus === 1,
			}));
		}
	};

	const handleIsActiveKitchen = async (id, currentStatus) => {
		// Update the `isActive` state immediately
		setIsActiveKitchen((prev) => ({
			...prev,
			[id]: !prev[id],
		}));

		try {
			// Make API request to update status
			const response = await axios.post(
				`${api_base_url}/updateKitchenActive/${id}/${currentStatus === 1 ? 0 : 1
				}/${logginedDB}`
			);

			if (response.status === 200) {
				handleGetKitchen();
			}
		} catch (error) {
			console.error("Error updating user status:", error);

			// Revert the change in case of an error
			setIsActiveKitchen((prev) => ({
				...prev,
				[id]: currentStatus === 1,
			}));
		}
	};

	const handleIsActiveDiscount = async (id, currentStatus) => {
		// Update the `isActive` state immediately
		setIsActiveDiscount((prev) => ({
			...prev,
			[id]: !prev[id],
		}));

		try {
			// Make API request to update status
			const response = await axios.post(
				`${api_base_url}/updateDiscountActive/${id}/${currentStatus === 1 ? 0 : 1
				}/${logginedDB}`
			);

			if (response.status === 200) {
				handleGetDiscount();
			}
		} catch (error) {
			console.error("Error updating user status:", error);

			// Revert the change in case of an error
			setIsActiveDiscount((prev) => ({
				...prev,
				[id]: currentStatus === 1,
			}));
		}
	};

	const handleIsActiveSubKitchen = async (id, currentStatus) => {
		// Update the `isActive` state immediately
		setIsActiveSubKitchen((prev) => ({
			...prev,
			[id]: !prev[id],
		}));

		try {
			// Make API request to update status
			const response = await axios.post(
				`${api_base_url}/updateSubKitchenActive/${id}/${currentStatus === 1 ? 0 : 1
				}/${logginedDB}`
			);

			if (response.status === 200) {
				handleGetSubKitchen();
			}
		} catch (error) {
			console.error("Error updating user status:", error);

			// Revert the change in case of an error
			setIsActiveSubKitchen((prev) => ({
				...prev,
				[id]: currentStatus === 1,
			}));
		}
	};

	const handleIsActiveCategory = async (id, currentStatus) => {
		// Update the `isActive` state immediately
		setIsActiveCategory((prev) => ({
			...prev,
			[id]: !prev[id],
		}));

		try {
			// Make API request to update status
			const response = await axios.post(
				`${api_base_url}/updateCategoryActive/${id}/${currentStatus === 1 ? 0 : 1
				}/${logginedDB}`
			);

			if (response.status === 200) {
				handleGetCategories();
			}
		} catch (error) {
			console.error("Error updating user status:", error);

			// Revert the change in case of an error
			setIsActiveCategory((prev) => ({
				...prev,
				[id]: currentStatus === 1,
			}));
		}
	};

	const handleIsActiveAddon = async (id, currentStatus) => {
		// Update the `isActive` state immediately
		setIsActiveAddon((prev) => ({
			...prev,
			[id]: !prev[id],
		}));

		try {
			// Make API request to update status
			const response = await axios.post(
				`${api_base_url}/updateAddonActive/${id}/${currentStatus === 1 ? 0 : 1
				}/${logginedDB}`
			);

			if (response.status === 200) {
				handleGetAddons();
			}
		} catch (error) {
			console.error("Error updating user status:", error);

			// Revert the change in case of an error
			setIsActiveAddon((prev) => ({
				...prev,
				[id]: currentStatus === 1,
			}));
		}
	};

	const [selectedAreas, setSelectedAreas] = useState([]);
	const [selectedTables, setSelectedTables] = useState([]);
	const [selectedKitchen, setSelectedKitchen] = useState([]);
	const [selectedSubKitchen, setSelectedSubKitchen] = useState([]);
	const [selectedItems, setSelectedItems] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState([]);
	const [selectedAddon, setSelectedAddon] = useState([]);
	const [selectedDiscount, setSelectedDiscount] = useState([]);

	const [isCheckedAll, setIsCheckedAll] = useState(false);
	const [isCheckedAllTables, setIsCheckedAllTables] = useState(false);
	const [isCheckedAllKitchen, setIsCheckedAllKitchen] = useState(false);
	const [isCheckedAllSubKitchen, setIsCheckedAllSubKitchen] = useState(false);
	const [isCheckedAllItems, setIsCheckedAllItems] = useState(false);
	const [isCheckedAllCategory, setIsCheckedAllCategory] = useState(false);
	const [isCheckedAllAddon, setIsCheckedAllAddon] = useState(false);
	const [isCheckedAllDiscount, setIsCheckedAllDiscount] = useState(false);

	const [checkedArea, setCheckedArea] = useState(
		areaInfo.map(() => false) // Initialize all as unchecked
	);
	const [checkedTables, setCheckedTables] = useState(
		tables.map(() => false) // Initialize all as unchecked
	);
	const [checkedKitchen, setCheckedKitchen] = useState(
		loadingKitchen.map(() => false) // Initialize all as unchecked
	);
	const [checkedSubKitchen, setCheckedSubKitchen] = useState(
		loadingSubKitchen.map(() => false) // Initialize all as unchecked
	);
	const [checkedItems, setCheckedItems] = useState(
		items.map(() => false) // Initialize all as unchecked
	);
	const [checkedCategory, setCheckedCategory] = useState(
		CategoryDbData.map(() => false) // Initialize all as unchecked
	);
	const [checkedAddon, setCheckedAddon] = useState(
		addonsData.map(() => false) // Initialize all as unchecked
	);
	const [checkedDiscount, setCheckedDiscount] = useState(
		discountList.map(() => false) // Initialize all as unchecked
	);

	// Handle "Select All" checkbox
	const handleIsCheckedAll = (e, field) => {
		if (field === "area") {
			const checked = e.target.checked;
			setIsCheckedAll(checked);
			setCheckedArea(areaInfo.map(() => checked)); // Set all checkboxes to the same state

			// Update selectedUsers with all or none
			if (checked) {
				setSelectedAreas(areaInfo.map((area) => area.Area_id)); // Add all user ids
			} else {
				setSelectedAreas([]); // Clear selection
			}
		} else if (field === "table") {
			const checked = e.target.checked;
			setIsCheckedAllTables(checked);
			setCheckedTables(tables.map(() => checked)); // Set all checkboxes to the same state

			// Update selectedUsers with all or none
			if (checked) {
				setSelectedTables(tables.map((table) => table.Table_id)); // Add all user ids
			} else {
				setSelectedTables([]); // Clear selection
			}
		} else if (field === "kitchen") {
			const checked = e.target.checked;
			setIsCheckedAllKitchen(checked);
			setCheckedKitchen(loadingKitchen.map(() => checked)); // Set all checkboxes to the same state

			// Update selectedUsers with all or none
			if (checked) {
				setSelectedKitchen(loadingKitchen.map((kitchen) => kitchen.Kitchen_id)); // Add all user ids
			} else {
				setSelectedKitchen([]); // Clear selection
			}
		} else if (field === "subKitchen") {
			const checked = e.target.checked;
			setIsCheckedAllSubKitchen(checked);
			setCheckedSubKitchen(loadingSubKitchen.map(() => checked)); // Set all checkboxes to the same state

			// Update selectedUsers with all or none
			if (checked) {
				setSelectedSubKitchen(
					loadingSubKitchen.map((kitchen) => kitchen.Sub_Kitchen_id)
				); // Add all user ids
			} else {
				setSelectedSubKitchen([]); // Clear selection
			}
		} else if (field === "items") {
			const checked = e.target.checked;
			setIsCheckedAllItems(checked);
			setCheckedItems(items.map(() => checked)); // Set all checkboxes to the same state

			// Update selectedUsers with all or none
			if (checked) {
				setSelectedItems(items.map((item) => item.id_productReg)); // Add all user ids
			} else {
				setSelectedItems([]); // Clear selection
			}
		} else if (field === "category") {
			const checked = e.target.checked;
			setIsCheckedAllCategory(checked);
			setCheckedCategory(CategoryDbData.map(() => checked)); // Set all checkboxes to the same state

			// Update selectedUsers with all or none
			if (checked) {
				setSelectedCategory(
					CategoryDbData.map((category) => category.id_category)
				); // Add all user ids
			} else {
				setSelectedCategory([]); // Clear selection
			}
		} else if (field === "addon") {
			const checked = e.target.checked;
			setIsCheckedAllAddon(checked);
			setCheckedAddon(addonsData.map(() => checked)); // Set all checkboxes to the same state

			// Update selectedUsers with all or none
			if (checked) {
				setSelectedAddon(addonsData.map((addon) => addon.id_addon)); // Add all user ids
			} else {
				setSelectedAddon([]); // Clear selection
			}
		} else if (field === "discount") {
			const checked = e.target.checked;
			setIsCheckedAllDiscount(checked);
			setCheckedDiscount(discountList.map(() => checked)); // Set all checkboxes to the same state

			// Update selectedUsers with all or none
			if (checked) {
				setSelectedDiscount(discountList.map((disc) => disc.id_Discount)); // Add all user ids
			} else {
				setSelectedDiscount([]); // Clear selection
			}
		}
	};

	// Handle individual checkboxes
	const handleIsChecked = (index, checked, field) => {
		if (field === "area") {
			const updatedChecked = [...checkedArea];
			updatedChecked[index] = checked;
			setCheckedArea(updatedChecked);

			// Update "Select All" state if not all items are selected
			const allChecked = updatedChecked.every((item) => item);
			setIsCheckedAll(allChecked);

			// Update selectedUsers based on checked state
			const updatedSelectedUsers = [...selectedAreas];
			const userId = areaInfo[index].Area_id;

			if (checked) {
				// Add the user id if checked
				updatedSelectedUsers.push(userId);
			} else {
				// Remove the user id if unchecked
				const userIndex = updatedSelectedUsers.indexOf(userId);
				if (userIndex !== -1) {
					updatedSelectedUsers.splice(userIndex, 1);
				}
			}

			setSelectedAreas(updatedSelectedUsers);
		} else if (field === "table") {
			const updatedChecked = [...checkedTables];
			updatedChecked[index] = checked;
			setCheckedTables(updatedChecked);

			// Update "Select All" state if not all items are selected
			const allChecked = updatedChecked.every((item) => item);
			setIsCheckedAllTables(allChecked);

			// Update selectedUsers based on checked state
			const updatedSelectedUsers = [...selectedTables];
			const userId = tables[index].Table_id;

			if (checked) {
				// Add the user id if checked
				updatedSelectedUsers.push(userId);
			} else {
				// Remove the user id if unchecked
				const userIndex = updatedSelectedUsers.indexOf(userId);
				if (userIndex !== -1) {
					updatedSelectedUsers.splice(userIndex, 1);
				}
			}

			setSelectedTables(updatedSelectedUsers);
		} else if (field === "kitchen") {
			const updatedChecked = [...checkedKitchen];
			updatedChecked[index] = checked;
			setCheckedKitchen(updatedChecked);

			// Update "Select All" state if not all items are selected
			const allChecked = updatedChecked.every((item) => item);
			setIsCheckedAllKitchen(allChecked);

			// Update selectedUsers based on checked state
			const updatedSelectedUsers = [...selectedKitchen];
			const userId = loadingKitchen[index].Kitchen_id;

			if (checked) {
				// Add the user id if checked
				updatedSelectedUsers.push(userId);
			} else {
				// Remove the user id if unchecked
				const userIndex = updatedSelectedUsers.indexOf(userId);
				if (userIndex !== -1) {
					updatedSelectedUsers.splice(userIndex, 1);
				}
			}

			setSelectedKitchen(updatedSelectedUsers);
		} else if (field === "subKitchen") {
			const updatedChecked = [...checkedSubKitchen];
			updatedChecked[index] = checked;
			setCheckedSubKitchen(updatedChecked);

			// Update "Select All" state if not all items are selected
			const allChecked = updatedChecked.every((item) => item);
			setIsCheckedAllSubKitchen(allChecked);

			// Update selectedUsers based on checked state
			const updatedSelectedUsers = [...selectedSubKitchen];
			const userId = loadingSubKitchen[index].Sub_Kitchen_id;

			if (checked) {
				// Add the user id if checked
				updatedSelectedUsers.push(userId);
			} else {
				// Remove the user id if unchecked
				const userIndex = updatedSelectedUsers.indexOf(userId);
				if (userIndex !== -1) {
					updatedSelectedUsers.splice(userIndex, 1);
				}
			}

			setSelectedSubKitchen(updatedSelectedUsers);
		} else if (field === "items") {
			const updatedChecked = [...checkedItems];
			updatedChecked[index] = checked;
			setCheckedItems(updatedChecked);

			// Update "Select All" state if not all items are selected
			const allChecked = updatedChecked.every((item) => item);
			setIsCheckedAllItems(allChecked);

			// Update selectedUsers based on checked state
			const updatedSelectedUsers = [...selectedItems];
			const userId = items[index].id_productReg;

			if (checked) {
				// Add the user id if checked
				updatedSelectedUsers.push(userId);
			} else {
				// Remove the user id if unchecked
				const userIndex = updatedSelectedUsers.indexOf(userId);
				if (userIndex !== -1) {
					updatedSelectedUsers.splice(userIndex, 1);
				}
			}

			setSelectedItems(updatedSelectedUsers);
		} else if (field === "category") {
			const updatedChecked = [...checkedCategory];
			updatedChecked[index] = checked;
			setCheckedCategory(updatedChecked);

			// Update "Select All" state if not all items are selected
			const allChecked = updatedChecked.every((item) => item);
			setIsCheckedAllCategory(allChecked);

			// Update selectedUsers based on checked state
			const updatedSelectedUsers = [...selectedCategory];
			const userId = CategoryDbData[index].id_category;

			if (checked) {
				// Add the user id if checked
				updatedSelectedUsers.push(userId);
			} else {
				// Remove the user id if unchecked
				const userIndex = updatedSelectedUsers.indexOf(userId);
				if (userIndex !== -1) {
					updatedSelectedUsers.splice(userIndex, 1);
				}
			}

			setSelectedCategory(updatedSelectedUsers);
		} else if (field === "addon") {
			const updatedChecked = [...checkedAddon];
			updatedChecked[index] = checked;
			setCheckedAddon(updatedChecked);

			// Update "Select All" state if not all items are selected
			const allChecked = updatedChecked.every((item) => item);
			setIsCheckedAllAddon(allChecked);

			// Update selectedUsers based on checked state
			const updatedSelectedUsers = [...selectedAddon];
			const userId = addonsData[index].id_addon;

			if (checked) {
				// Add the user id if checked
				updatedSelectedUsers.push(userId);
			} else {
				// Remove the user id if unchecked
				const userIndex = updatedSelectedUsers.indexOf(userId);
				if (userIndex !== -1) {
					updatedSelectedUsers.splice(userIndex, 1);
				}
			}

			setSelectedAddon(updatedSelectedUsers);
		} else if (field === "discount") {
			const updatedChecked = [...checkedDiscount];
			updatedChecked[index] = checked;
			setCheckedDiscount(updatedChecked);

			// Update "Select All" state if not all items are selected
			const allChecked = updatedChecked.every((item) => item);
			setIsCheckedAllDiscount(allChecked);

			// Update selectedUsers based on checked state
			const updatedSelectedUsers = [...selectedDiscount];
			const userId = discountList[index].id_Discount;

			if (checked) {
				// Add the user id if checked
				updatedSelectedUsers.push(userId);
			} else {
				// Remove the user id if unchecked
				const userIndex = updatedSelectedUsers.indexOf(userId);
				if (userIndex !== -1) {
					updatedSelectedUsers.splice(userIndex, 1);
				}
			}

			setSelectedDiscount(updatedSelectedUsers);
		}
	};

	function formatDate(inputDate) {
		const date = new Date(inputDate); // Parse the input date string

		// Extract day, month, and year
		const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits
		const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
		const year = date.getFullYear();

		return `${day}-${month}-${year}`;
	}

	const [viewDetails, setViewDetails] = useState(null);
	const [isExiting, setIsExiting] = useState(false);

	const handleToView = (info) => {
		setViewDetails(info);
		setIsExiting(false);
	};

	const handleClose = () => {
		setIsExiting(true);
		setTimeout(() => {
			setViewDetails(null);
		}, 300); // Match the animation duration
	};

	const handleToDeleteItem = async () => {
		if (selectedItems.length > 0) {
			const userConfirmed = window.confirm(`Delete selected item?`);

			if (!userConfirmed) {
				return;
			}
			try {
				const response = await axios.post(
					`${api_base_url}/deleteItems/${logginedDB}/${customerCode}`,
					selectedItems
				);
				if (response.status === 200) {
					toast.success(`Successfully deleted!`, {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
					handleGetItems();
					setCheckedItems(items.map(() => false));
					setIsCheckedAllItems(false);
				}
			} catch (error) {
				//(error);
			}
		} else {
			alert("Select any item!");
		}
	};

	const handleToDeleteArea = async () => {
		if (selectedAreas.length > 0) {
			const userConfirmed = window.confirm(`Delete selected area?`);

			if (!userConfirmed) {
				return;
			}
			try {
				const response = await axios.post(
					`${api_base_url}/deleteAreas/${logginedDB}`,
					selectedAreas
				);
				if (response.status === 200) {
					toast.success(`Successfully deleted!`, {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
					fetchData();
					setCheckedArea(areaInfo.map(() => false));
					setIsCheckedAll(false);
				}
			} catch (error) {
				//(error);
			}
		} else {
			alert("Select any area!");
		}
	};

	const handleToDeleteTable = async (area) => {
		if (selectedTables.length > 0) {
			const userConfirmed = window.confirm(`Delete selected table?`);

			if (!userConfirmed) {
				return;
			}
			try {
				const response = await axios.post(
					`${api_base_url}/deleteTables/${logginedDB}/${area}`,
					selectedTables
				);
				if (response.status === 200) {
					// //(response.data.success);

					if (response.data.success) {
						toast.success(`Successfully deleted!`, {
							className: "custom-toast",
							bodyClassName: "custom-toast-container",
							closeButtonClassName: "custom-toast-close-button",
							onClose: () => { },
						});
						handleGetTables();
						setCheckedTables(tables.map(() => false));
						setIsCheckedAllTables(false);
					} else {
						alert("Table Ahead!");
					}
				}
			} catch (error) {
				//(error);
			}
		} else {
			alert("Select any table!");
		}
	};

	const handleToDeleteKitchen = async () => {
		const currentDate = new Date().toISOString().split("T")[0];

		const formatTime = () => {
			let now = new Date();
			let hours = now.getHours();
			let minutes = now.getMinutes();
			const ampm = hours >= 12 ? "PM" : "AM";
			hours = hours % 12 || 12; // Convert 24-hour to 12-hour format
			minutes = minutes.toString().padStart(2, "0"); // Ensure two-digit minutes
			return `${hours}:${minutes} ${ampm}`;
		};

		const eventDetails = {
			ddate: currentDate,
			ttime: formatTime(),
			user_Id: user_Id, // Replace with actual user ID variable
			// user: userName // Replace with actual user variable
		};

		if (selectedKitchen.length > 0) {
			const userConfirmed = window.confirm(`Delete selected kitchen?`);

			if (!userConfirmed) {
				return;
			}
			try {
				const response = await axios.post(
					`${api_base_url}/deleteKitchens/${logginedDB}/${JSON.stringify(
						eventDetails
					)}`,
					selectedKitchen
				);
				if (response.status === 200) {
					toast.success(`Successfully deleted!`, {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
					handleGetKitchen();
					setCheckedKitchen(loadingKitchen.map(() => false));
					setIsCheckedAllKitchen(false);
				}
			} catch (error) {
				//(error);
			}
		} else {
			alert("Select any category!");
		}
	};

	const handleToDeleteDiscount = async () => {
		const currentDate = new Date().toISOString().split("T")[0];

		const formatTime = () => {
			let now = new Date();
			let hours = now.getHours();
			let minutes = now.getMinutes();
			const ampm = hours >= 12 ? "PM" : "AM";
			hours = hours % 12 || 12; // Convert 24-hour to 12-hour format
			minutes = minutes.toString().padStart(2, "0"); // Ensure two-digit minutes
			return `${hours}:${minutes} ${ampm}`;
		};

		const eventDetails = {
			ddate: currentDate,
			ttime: formatTime(),
			user_Id: user_Id, // Replace with actual user ID variable
			// user: userName // Replace with actual user variable
		};

		if (discountList.length > 0) {
			const userConfirmed = window.confirm(`Delete selected kitchen?`);

			if (!userConfirmed) {
				return;
			}
			try {
				const response = await axios.post(
					`${api_base_url}/deleteDiscounts/${logginedDB}/${JSON.stringify(
						eventDetails
					)}`,
					selectedDiscount
				);
				if (response.status === 200) {
					toast.success(`Successfully deleted!`, {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
					handleGetDiscount();
					setCheckedDiscount(loadingKitchen.map(() => false));
					setIsCheckedAllDiscount(false);
				}
			} catch (error) {
				//(error);
			}
		} else {
			alert("Select any discount!");
		}
	};

	const handleToDeleteCategory = async () => {
		if (selectedCategory.length > 0) {
			const userConfirmed = window.confirm(`Delete selected category?`);

			if (!userConfirmed) {
				return;
			}
			try {
				const response = await axios.post(
					`${api_base_url}/deleteCategories/${logginedDB}`,
					selectedCategory
				);
				if (response.status === 200) {
					toast.success(`Successfully deleted!`, {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
					handleGetCategories();
					setCheckedCategory(CategoryDbData.map(() => false));
					setIsCheckedAllCategory(false);
				}
			} catch (error) {
				//(error);
			}
		} else {
			alert("Select any category!");
		}
	};

	const handleToDeleteSubKitchen = async () => {
		if (selectedSubKitchen.length > 0) {
			const userConfirmed = window.confirm(`Delete selected sub kitchens?`);

			if (!userConfirmed) {
				return;
			}
			try {
				const response = await axios.post(
					`${api_base_url}/deleteSubKitchens/${logginedDB}`,
					selectedSubKitchen
				);
				if (response.status === 200) {
					toast.success(`Successfully deleted!`, {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
					handleGetSubKitchen();
					setCheckedSubKitchen(loadingSubKitchen.map(() => false));
					setIsCheckedAllSubKitchen(false);
				}
			} catch (error) {
				//(error);
			}
		} else {
			alert("Select any sub kitchen!");
		}
	};

	const handleToDeleteAddon = async () => {
		if (selectedAddon.length > 0) {
			const userConfirmed = window.confirm(`Delete selected addons?`);

			if (!userConfirmed) {
				return;
			}
			try {
				const response = await axios.post(
					`${api_base_url}/deleteAddons/${logginedDB}`,
					selectedAddon
				);
				if (response.status === 200) {
					toast.success(`Successfully deleted!`, {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
					handleGetAddons();
					setCheckedAddon(addonsData.map(() => false));
					setIsCheckedAllAddon(false);
				}
			} catch (error) {
				//(error);
			}
		} else {
			alert("Select any sub kitchen!");
		}
	};

	function formatISODateToDDMMYYYY(isoDateString) {
		const date = new Date(isoDateString); // Convert ISO string to Date object
		const dd = String(date.getDate()).padStart(2, "0"); // Day with leading zero
		const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month with leading zero
		const yyyy = date.getFullYear(); // Year
		return `${dd}-${mm}-${yyyy}`;
	}

	const toEditItem = (item) => {
		console.log(item, "itemms");

		navigate("/EditItem", {
			state: {
				id_productReg: item.id_productReg
				//  Cess: item.Cess,
				//  Tax: item.Tax,
				//  avgTime: item.avgTime,
				//  category: item.category,
				//  final_rete: item.final_rate,
				//  foodType: item.foodType,
				//  imageBase64: item.imageBase64,
				//  imgName: item.imgName,
				//  isVarientExist: item.isVarientExist,
				//  itemCode: item.itemCode,
				//  kitchen:  item.kitchen,
				//  productName: item.productName,
				//  rate: item.rate,
				//  regionalName: item.regionalName,
				//  subKitchen: item.subKitchen

			},
		});
	};

	// const handleSearch = () => {
	//   const searchData = CategoryDbData.filter(val =>
	//     val.Category_Name.toLowerCase().includes(search.toLowerCase())
	//   );
	//   setCategoryDbData(searchData);
	// };

	// const handleShow = () => {
	//     handleGetCategories();
	//     setSearch("");
	// };

	const handleAreaSearch = () => {
		const searchArea = areaInfo.filter((val) =>
			val.AreaName.toLowerCase().includes(search.toLowerCase())
		);
		setAreaInfo(searchArea);
	};

	const handleAreadShow = () => {
		fetchData();
		setSearch("");
	};

	return (
		<div className="w-full h-full flex flex-col overflow-hidden">
			<SherDineNav
				sideNav={(state) => handleSideNav(state)}
				falseState={falseState}
			/>
			<div className="w-full bg-[#f5f5f5] flex gap-3 h-full overflow-hidden">
				<div className="w-max h-full z-[9999]">
					<SideNav
						focus={"Menu"}
						state={sideNav}
						falseState={(state) => setFalseState(state)}
					/>
				</div>
				<div className="w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3 overflow-hidden relative">
					<div className="pr-3 h-max w-full bg-[#fff] borderBottom">
						<TopRootDiv
							image={"Menu Management"}
							root={["Menu Management"]}
							section={"Base menu"}
						/>
					</div>
					<div className="relative w-full h-full flex flex-col gap-3 overflow-hidden">
						<div className="MenuReg_List w-full h-max">
							<div
								className={`rounded-tl-[.313rem] ${item ? "MenuActive" : ""}`}
								onClick={toItem}
							>
								Item
							</div>
							<div
								className={category ? "MenuActive" : ""}
								onClick={toCategory}
							>
								Category
							</div>
							<div className={addons ? "MenuActive" : ""} onClick={toAddons}>
								Addons/Combo
							</div>
							<div
								className={tableArea ? "MenuActive" : ""}
								onClick={toTable_Area}
							>
								Tables/Area
							</div>
							<div className={taxes ? "MenuActive" : ""} onClick={toTaxes}>
								Taxes
							</div>
							<div
								className={discount ? "MenuActive" : ""}
								onClick={toDiscount}
							>
								Discount
							</div>
							<div
								className={`rounded-tr-[.313rem] ${kitchens ? `MenuActive` : ""
									}`}
								onClick={toKitchen}
							>
								Kitchen
							</div>
						</div>

						{/*............................................... category ............................................. */}

						{category && (
							<div className="h-full flex flex-col bg-[#fff] overflow-auto customScroll">
								{/* <div className='w-full h-max flex p-3'> */}
								{/* {
                                            category.length > 0 ? (
                                                <div className='w-1/2'>
                                                    <div className='w-1/2 flex border border-[#ccc] rounded-[.313rem]'>
                                                        <div className='flex justify-center items-center p-2'>
                                                            <img className='w-[1rem]' src={Search} alt="?" />
                                                        </div>
                                                        <input className='w-full pr-2 border-none' type="text" placeholder='Search...' />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className='w-1/2 font-nunito flex justify-start items-center'>Category not registered yet.</div>
                                            )
                                        } */}
								{/* <div className='h-max flex w-full justify-end items-center font-[600]'>  */}
								{/* {categoryCategory && <button className='pt-[.25rem] pb-[.25rem] pl-3 pr-3 loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]' onClick={() => navigate('/categoryreg')}>Add Category</button>} */}
								{/* {categoryParent && <button className='pt-[.25rem] pb-[.25rem] pl-3 pr-3 loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]' onClick={() => navigate('/categoryreg')}>Add Parent Category</button>} */}
								{/* {categoryGrouping && <button className='pt-[.25rem] pb-[.25rem] pl-3 pr-3 loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]' onClick={() => navigate('/categoryreg')}>Grouping</button>} */}
								{/* {categoryMenu && <button className='pt-[.25rem] pb-[.25rem] pl-3 pr-3 loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]' onClick={() => navigate('/categoryreg')}>Add Category</button>} */}
								{/* </div> */}
								{/* <div className='w-max h-max flex text-[.938em] font-[600] font-nunito rounded-t-[.313rem] bg-[#fff]'> */}
								{/* <div className={`flex justify-center items-center pl-5 pr-5 pt-3 pb-3 cursor-pointer ${categoryParent ? "MenuCategoryActive" : "MenuCategoryNotActive"}`} onClick={toCategoryParent}><span>Parent Category</span></div> */}
								{/* <div className={`flex justify-center items-center pl-5 pr-5 pt-3 pb-3 cursor-pointer ${categoryCategory ? 'MenuCategoryActive' : 'MenuCategoryNotActive'}`} onClick={toCategoryCategory}><span>Category</span></div> */}
								{/* <div className={`flex justify-center items-center pl-5 pr-5 pt-3 pb-3 cursor-pointer ${categoryGrouping ? 'MenuCategoryActive' : 'MenuCategoryNotActive'}`} onClick={toCategoryGrouping}><span>Grouping</span></div> */}
								{/* <div className={`flex justify-center items-center pl-5 pr-5 pt-3 pb-3 cursor-pointer ${categoryMenu ? 'MenuCategoryActive' : 'MenuCategoryNotActive'}`} onClick={toCategoryMenu}><span>Menu configaration</span></div> */}
								{/* </div> */}
								{/* </div> */}
								{categoryCategory && (
									<div className="h-full flex flex-col bg-[#fff] overflow-auto customScroll">
										<div className="w-full h-max flex p-3">
											{CategoryDbData.length > 0 ? (
												<div className="w-1/2">
													<div className="w-1/2 flex border border-[#ccc] rounded-[.313rem]">
														<div className="flex justify-center items-center p-2">
															<img className="w-[1rem]" src={Search} alt="?" />
														</div>
														<input
															className="w-full pr-2 border-none"
															onChange={(e) => setSearch(e.target.value)}
															type="text"
															placeholder="Searchs..."
														/>
													</div>
												</div>
											) : (
												<div className="w-1/2 font-nunito flex justify-start items-center">
													Category not registered yet.
												</div>
											)}
											<div className="w-1/2 flex justify-end items-center font-nunito text-[1rem]">
												<button
													className="pt-[.25rem] pb-[.25rem] pl-3 pr-3 loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]"
													onClick={() => navigate("/categoryreg")}
												>
													Add Category
												</button>
											</div>
										</div>

										{CategoryDbData.length > 0 && (
											<div className="font-nunito flex flex-col text-center overflow-hidden">
												<div className="flex w-full bg-[#E5E5E5] font-[600] rounded-t-[.313rem]">
													<div className="p-3 w-1/12">
														<input
															type="checkbox"
															checked={isCheckedAllCategory}
															onChange={(e) =>
																handleIsCheckedAll(e, "category")
															}
														/>
													</div>
													<div className="p-3 w-4/12 text-left">Name</div>
													<div className="p-3 w-2/12">Created</div>
													<div className="p-3 w-2/12">Modified</div>
													<div className="p-3 w-2/12">Status</div>
													<div className="p-3 w-3/12">Action</div>
												</div>
												<div className="font-400 flex flex-col overflow-auto customScroll">
													{filtertCategory?.map((Category, index) => (
														<div className="flex" key={index}>
															<div className="p-3 w-1/12">
																<input
																	type="checkbox"
																	checked={checkedCategory[index]}
																	onChange={(e) =>
																		handleIsChecked(
																			index,
																			e.target.checked,
																			"category"
																		)
																	}
																/>
															</div>
															<div className="p-3 w-4/12 text-left">
																{Category.Category_Name}
															</div>
															<div className="p-3 w-2/12">
																{Category.createdDate
																	? formatISODateToDDMMYYYY(
																		Category.createdDate
																	)
																	: "-"}
															</div>
															<div className="p-3 w-2/12">
																{Category.modifiedDate
																	? formatISODateToDDMMYYYY(
																		Category.modifiedDate
																	)
																	: "-"}
															</div>
															<div className="w-2/12 p-2 flex justify-center items-center relative">
																<input
																	type="checkbox"
																	id="active_inactive_checkbox"
																	checked={
																		isActiveCategory[Category.id_category] ||
																		false
																	}
																	readOnly
																/>
																<div
																	className="active_inactive_div"
																	onClick={() =>
																		handleIsActiveCategory(
																			Category.id_category,
																			Category.Status
																		)
																	}
																></div>
															</div>
															{checkedCategory[index] ? (
																<div className="p-3 w-3/12 flex justify-center items-center gap-2">
																	<img
																		className="w-[1rem] cursor-pointer"
																		src={remove}
																		alt=""
																		onClick={handleToDeleteCategory}
																	/>
																</div>
															) : (
																<div className="p-3 w-3/12 flex justify-center items-center gap-2">
																	{/* <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(Category)}/> */}
																	<img
																		className="w-[1rem] cursor-pointer"
																		src={Editing1}
																		alt=""
																		onClick={() =>
																			navigate("/categoryreg", {
																				state: {
																					id: Category.id_category,
																					category: Category.Category_Name,
																				},
																			})
																		}
																	/>
																</div>
															)}
														</div>
													))}
												</div>
											</div>
										)}
									</div>
								)}
							</div>
						)}

						{/*............................................... item ............................................. */}

						{item && (
							<div className="h-full flex flex-col bg-[#fff] overflow-auto customScroll">
								<div className="w-full h-max flex p-3">
									{items.length > 0 ? (
										<div className="w-1/2">
											<div className="w-1/2 flex border border-[#ccc] rounded-[.313rem]">
												<div className="flex justify-center items-center p-2">
													<img className="w-[1rem]" src={Search} alt="?" />
												</div>
												<input
													className="w-full pr-2 border-none"
													onChange={(e) => setSearch(e.target.value)}
													type="text"
													placeholder="Searchs..."
												/>
											</div>
										</div>
									) : (
										<div className="w-1/2 font-nunito flex justify-start items-center">
											Item not registered yet.
										</div>
									)}
									<div className="w-1/2 flex justify-end items-center font-nunito text-[1rem]">
										<button
											className="bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3 focus:outline-none"
											onClick={toAddItem}
										>
											Add Item
										</button>
									</div>
								</div>

								{items.length > 0 && (
									<div className="flex flex-col w-full h-full text-center font-nunito text-[1rem]">
										<div className="w-full h-max flex font-[600] sticky top-0 bg-[#E5E5E5] z-[1111] rounded-t-[.313rem]">
											<div className="w-1/12 p-3">
												<input
													type="checkbox"
													checked={isCheckedAllItems}
													onChange={(e) => handleIsCheckedAll(e, "items")}
												/>
											</div>
											<div className="w-2/12 p-3">Image</div>
											<div className="w-3/12 p-3 text-left">Name</div>
											<div className="w-2/12 p-3">Item Code</div>
											<div className="w-2/12 p-3">Price</div>
											{/* <div className='w-2/12 p-3'>Description</div> */}
											<div className="w-2/12 p-3">Action</div>
										</div>
										<div className="flex flex-col w-full">
											{filteterItem?.map((item, index) => {
												const image = item.imageBase64;
												//('image',image);

												return (
													<div key={index} className="flex w-full">
														<div className="w-1/12 p-3 flex justify-center items-center">
															<input
																type="checkbox"
																checked={checkedItems[index]}
																onChange={(e) =>
																	handleIsChecked(
																		index,
																		e.target.checked,
																		"items"
																	)
																}
															/>
														</div>
														<div className="w-2/12 p-3 flex justify-center items-center">
															<img
																className="table_item_AddImg"
																src={image ? image : noImage}
																alt=""
																onClick={() =>
																	handleImageClick(image ? image : noImage)
																}
															/>
														</div>
														<div className="w-3/12 p-3 text-left flex justify-start items-center">
															{item.productName}
														</div>
														<div className="w-2/12 p-3 flex justify-center items-center">
															{item.itemCode}
														</div>
														<div className="w-2/12 p-3 flex justify-center items-center text-nowrap">
															₹ {item.final_rate}
														</div>
														{/* <div className='w-2/12 p-3 flex justify-center items-center'>descr</div> */}
														{checkedItems[index] ? (
															<div className="w-2/12 p-3 flex justify-center items-center gap-2">
																<img
																	className="w-[1rem] cursor-pointer"
																	src={remove}
																	alt=""
																	onClick={handleToDeleteItem}
																/>
															</div>
														) : (
															<div className="w-2/12 p-3 flex justify-center items-center gap-2">
																<img
																	className="w-[1rem] cursor-pointer"
																	src={Editing1}
																	alt=""
																	onClick={() => toEditItem(item)}
																/>
															</div>
														)}
													</div>
												);
											})}
										</div>
									</div>
								)}
							</div>
						)}
						{modalImage && (
							<ModalImage imageUrl={modalImage} onClose={closeModal} />
						)}

						{/* ..........................................................addon.................................................. */}

						{addons && (
							<div className="h-full flex flex-col bg-[#fff] overflow-hidden">
								<div className="w-full h-max flex p-3">
									{addonsData.length > 0 ? (
										<div className="w-1/2">
											<div className="w-1/2 flex border border-[#ccc] rounded-[.313rem]">
												<div className="flex justify-center items-center p-2">
													<img className="w-[1rem]" src={Search} alt="?" />
												</div>
												<input
													className="w-full pr-2 border-none"
													onChange={(e) => setSearch(e.target.value)}
													type="text"
													placeholder="Search..."
												/>
											</div>
										</div>
									) : (
										<div className="w-1/2 font-nunito flex justify-start items-center">
											Addons/Combo not registered yet.
										</div>
									)}
									<div className="w-1/2 flex justify-end items-center font-nunito text-[1rem]">
										<button
											className="bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3 focus:outline-none"
											onClick={toAddAddon}
										>
											Add Addon
										</button>
									</div>
								</div>
								{addonsData.length > 0 && (
									<div className="flex flex-col w-full h-full text-center font-nunito text-[1rem] overflow-hidden">
										<div className="w-full flex font-[600] bg-[#E5E5E5] rounded-t-[.313rem]">
											<div className="w-1/12 p-3">
												<input
													type="checkbox"
													checked={isCheckedAllAddon}
													onChange={(e) => handleIsCheckedAll(e, "addon")}
												/>
											</div>
											<div className="w-1/12 p-3 flex justify-center items-center">
												Image
											</div>
											<div className="w-3/12 p-3 text-left">Name</div>
											<div className="w-3/12 p-3">Price</div>
											<div className="w-2/12 p-3">Active</div>
											<div className="w-2/12 p-3">Action</div>
										</div>
										<div className="flex flex-col w-full overflow-auto customScroll">
											{filteterAdon.map((addon, index) => (
												<div key={index} className="flex w-full">
													<div className="w-1/12 p-3 flex justify-center items-center">
														<input
															type="checkbox"
															checked={checkedAddon[index]}
															onChange={(e) =>
																handleIsChecked(
																	index,
																	e.target.checked,
																	"addon"
																)
															}
														/>
													</div>
													<div className="w-1/12 p-3 flex justify-center items-center">
														<img
															className="table_item_AddImg"
															src={`${api_base_url}/uploads/${customerCode}/${logginedDB}/addons/${addon.imgName}`}
															alt=""
															onClick={() =>
																handleImageClick(
																	`${api_base_url}/uploads/${customerCode}/${logginedDB}/addons/${addon.imgName}`
																)
															}
														/>
													</div>
													<div className="w-3/12 p-3 text-left flex justify-start items-center">
														{addon.addon_name}
													</div>
													<div className="w-3/12 p-3 flex justify-center items-center">
														₹ {addon.addon_rate}
													</div>
													<div className="w-2/12 p-3 flex justify-center items-center relative">
														<input
															type="checkbox"
															id="active_inactive_checkbox"
															checked={isActiveAddon[addon.id_addon] || false}
															readOnly
														/>
														<div
															className="active_inactive_div"
															onClick={() =>
																handleIsActiveAddon(
																	addon.id_addon,
																	addon.Status
																)
															}
														></div>
													</div>
													{checkedAddon[index] ? (
														<div className="w-2/12 p-3 flex justify-center items-center gap-2">
															<img
																className="w-[1rem] cursor-pointer"
																src={remove}
																alt=""
																onClick={handleToDeleteAddon}
															/>
														</div>
													) : (
														<div className="w-2/12 p-3 flex justify-center items-center gap-2">
															{/* <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(addon)}/> */}
															<img
																className="w-[1rem] cursor-pointer"
																src={Editing1}
																alt=""
																onClick={() =>
																	navigate("/EditAddon", {
																		state: {
																			id_addon: addon.id_addon,
																			addon_name: addon.addon_name,
																		},
																	})
																}
															/>
														</div>
													)}
												</div>
											))}
										</div>
									</div>
								)}
							</div>
						)}

						{/*................................................. tableArea................................................................. */}

						{tableArea && (
							<div className="overflow-hidden flex flex-col w-full h-full">

								<div className="w-full h-max flex justify-between text-[.938em] font-[600] font-nunito rounded-t-[.313rem] bg-[#fff]">
									<div className="flex">
										<div
											className={`flex justify-center items-center pl-5 pr-5 pt-3 pb-3 cursor-pointer ${tableArea_Areas
												? "MenuCategoryActive"
												: "MenuCategoryNotActive"
												}`}
											onClick={toTableArea_Areas}
										>
											<span>Areas</span>
										</div>
										<div
											className={`flex justify-center items-center pl-5 pr-5 pt-3 pb-3 cursor-pointer ${tableArea_Tables
												? "MenuCategoryActive"
												: "MenuCategoryNotActive"
												}`}
											onClick={toTableArea_Tables}
										>
											<span>Tables</span>
										</div>
									</div>
									<div className="flex justify-end items-center font-[600]">
										{tableArea_Areas && (
											<button
												className="pt-[.25rem] pb-[.25rem] pl-3 pr-3 loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]"
												onClick={toAddArea}
											>
												Add Area
											</button>
										)}
										{tableArea_Tables && (
											<button
												className="pt-[.25rem] pb-[.25rem] pl-3 pr-3 loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]"
												onClick={toAddTable}
											>
												Add Table
											</button>
										)}
									</div>
								</div>
								{tableArea_Areas && areaInfo.length > 0 ? (
									<div className="p-3 flex gap-2 font-nunito text-[.95em]">
										<input
											className="pl-2 pr-2 pt-[.25rem] pb-[.25rem]"
											value={search}
											onChange={(e) => setSearch(e.target.value)}
											type="text"
											placeholder="Area Name"
										/>
										<button
											className="pl-3 pr-3 pt-[.25rem] pb-[.25rem] loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]"
											onClick={handleAreaSearch}
										>
											Search
										</button>
										<button
											className="pl-3 pr-3 pt-[.25rem] pb-[.25rem] border text-[#424242] bg-[#e0e0e0] rounded-[.313rem]"
											onClick={handleAreadShow}
										>
											Show all
										</button>
									</div>
								) : (
									<div>

									</div>
								)}
								{tableArea_Areas && areaInfo.length > 0 ? (
									<div className="h-full flex flex-col bg-[#fff] overflow-hidden">
										<div className="font-nunito flex flex-col text-center overflow-hidden">
											<div className="flex w-full bg-[#E5E5E5] font-[600] rounded-t-[.313rem]">
												<div className="p-3 w-1/12">
													<input
														type="checkbox"
														checked={isCheckedAll}
														onChange={(e) => handleIsCheckedAll(e, "area")}
													/>
												</div>
												<div className="p-3 w-2/12 text-left">Area Name</div>
												<div className="p-3 w-1/12">Tables</div>
												<div className="p-3 w-2/12">Created Date</div>
												<div className="p-3 w-2/12">Modified Date</div>
												<div className="p-3 w-2/12">Status</div>
												<div className="p-3 w-2/12">Action</div>
											</div>
											<div className="font-400 flex flex-col overflow-auto customScroll">
												{areaInfo.map((area, index) => (
													<div className="flex" key={index}>
														<div className="p-3 w-1/12">
															<input
																type="checkbox"
																checked={checkedArea[index]}
																onChange={(e) =>
																	handleIsChecked(
																		index,
																		e.target.checked,
																		"area"
																	)
																}
															/>
														</div>
														<div className="p-3 w-2/12 text-left">
															{area.AreaName}
														</div>
														<div className="p-3 w-1/12">{area.AreaTables}</div>
														{/* <div className='p-3 w-2/12'>{area.Status}</div> */}
														<div className="p-3 w-2/12">
															{area.createdDate
																? formatDate(area.createdDate)
																: "-"}
														</div>
														<div className="p-3 w-2/12">
															{area.modifiedDate
																? formatDate(area.modifiedDate)
																: "-"}
														</div>
														<div className="w-2/12 p-2 flex justify-center items-center relative">
															<input
																type="checkbox"
																id="active_inactive_checkbox"
																checked={isActive[area.Area_id] || false}
																readOnly
															/>
															<div
																className="active_inactive_div"
																onClick={() =>
																	handleIsActive(area.Area_id, area.Status)
																}
															></div>
														</div>
														{checkedArea[index] ? (
															<div className="p-3 w-2/12 flex justify-center items-center gap-2">
																<img
																	className="w-[1rem] cursor-pointer"
																	src={remove}
																	alt=""
																	onClick={handleToDeleteArea}
																/>
															</div>
														) : (
															<div className="p-3 w-2/12 flex justify-center items-center gap-2">
																{/* <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(item)}/> */}
																<img
																	className="w-[1rem] cursor-pointer"
																	src={Editing1}
																	alt=""
																	onClick={() =>
																		navigate("/tableareareg", {
																			state: {
																				id: area.Area_id,
																				area: area.AreaName,
																			},
																		})
																	}
																/>
															</div>
														)}
														{/* <div className='p-3 w-2/12 flex justify-center items-center gap-2'>
                                                            <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(area)}/>
                                                            <img className='w-[1rem] cursor-pointer' src={Editing1} alt="" onClick={() => navigate('/tableareareg',{
                                                                state: {
                                                                    id: area.Area_id,
                                                                    area: area.AreaName
                                                                }
                                                            })}/>
                                                        </div> */}
													</div>
												))}
											</div>
										</div>
									</div>
								) : (
									tableArea_Areas && (
										<div className="w-full h-full bg-[#fff] overflow-hidden p-3 font-nunito">
											Area not registered yet.
										</div>
									)
								)}
								{tableArea_Tables && (
									<div className="h-full flex flex-col bg-[#fff] overflow-hidden">
										<div className="category_Input_Search">
											{/* <input type="text" placeholder='Table Number' />
                                            <button className='category_search'>Search</button>
                                            <button className='ShowAll_Button'>Show all</button> */}
											<div className="w-1/3">
												<Select
													styles={customStyles}
													placeholder="Area"
													value={selectedOption}
													options={options}
													onChange={(selectedOption) =>
														handleChange(selectedOption)
													}
												// components={{
												// 	Option: CustomOption,
												// 	SingleValue: CustomSingleValue,
												// 	Placeholder: CustomPlaceholder
												// }}
												// isDisabled={true}
												/>
											</div>
										</div>
										{selectedOption && tables.length > 0 ? (
											<div className="font-nunito flex flex-col text-center overflow-hidden">
												<div className="flex w-full bg-[#E5E5E5] font-[600] rounded-t-[.313rem]">
													<div className="p-3 w-1/12">
														<input
															type="checkbox"
															checked={isCheckedAllTables}
															onChange={(e) => handleIsCheckedAll(e, "table")}
														/>
													</div>
													<div className="p-3 w-1/12 text-left">Table</div>
													<div className="p-3 w-1/12">Persons</div>
													{/* <div className='p-3 w-2/12'>Info</div> */}
													<div className="p-3 w-2/12">Created Date</div>
													<div className="p-3 w-2/12">Modified Date</div>
													<div className="p-3 w-2/12">Name</div>
													{/* <div className='p-3 w-2/12'>Area</div> */}
													<div className="p-3 w-2/12">Status</div>
													<div className="p-3 w-2/12">Action</div>
												</div>
												<div className="font-400 flex flex-col overflow-auto customScroll">
													{tables.map((table, index) => (
														<div className="flex" key={index}>
															<div className="p-3 w-1/12">
																<input
																	type="checkbox"
																	checked={checkedTables[index]}
																	onChange={(e) =>
																		handleIsChecked(
																			index,
																			e.target.checked,
																			"table"
																		)
																	}
																/>
															</div>
															<div className="p-3 w-1/12 text-left">
																{table.Table_onlineName}
															</div>
															<div className="p-3 w-1/12">
																{table.Table_Capacity}
															</div>
															{/* <div className='p-3 w-2/12 truncate'>{table.Table_info}</div> */}
															<div className="p-3 w-2/12">
																{table.createdDate
																	? formatDate(table.createdDate)
																	: "-"}
															</div>
															<div className="p-3 w-2/12">
																{table.modifiedDate
																	? formatDate(table.modifiedDate)
																	: "-"}
															</div>
															<div className="p-3 w-2/12">
																{table.Table_onlineName}
															</div>
															{table.Table_Status === 1 ? (
																<div className="w-2/12 p-2 flex justify-center items-center relative">
																	<input
																		type="checkbox"
																		id="active_inactive_checkbox"
																		checked={
																			isActiveTable[table.Table_id] || false
																		}
																		readOnly
																	/>
																	<div
																		className="active_inactive_div"
																		onClick={() =>
																			handleIsActiveTable(
																				table.Table_id,
																				table.Status
																			)
																		}
																	></div>
																</div>
															) : table.Table_Status === 2 ? (
																<div className="w-2/12 p-2 flex justify-center items-center">
																	<span className="text-[#29C65D] font-lato font-[500]">
																		Running Table
																	</span>
																</div>
															) : table.Table_Status === 3 ? (
																<div className="w-2/12 p-2 flex justify-center items-center">
																	<span className="text-[#E5E918] font-lato font-[500]">
																		Printed Table
																	</span>
																</div>
															) : table.Table_Status === 4 ? (
																<div className="w-2/12 p-2 flex justify-center items-center">
																	<span className="text-[#744D29] font-lato font-[500]">
																		Running KOT
																	</span>
																</div>
															) : (
																table.Table_Status === 5 && (
																	<div className="w-2/12 p-2 flex justify-center items-center">
																		<span className="text-[#FF001F] font-lato font-[500]">
																			Reserved
																		</span>
																	</div>
																)
															)}
															{checkedTables[index] ? (
																<div className="p-3 w-2/12 flex justify-center items-center gap-2">
																	<img
																		className="w-[1rem] cursor-pointer"
																		src={remove}
																		alt=""
																		onClick={() =>
																			handleToDeleteTable(table.Area)
																		}
																	/>
																</div>
															) : (
																<div className="p-3 w-2/12 flex justify-center items-center gap-2">
																	{/* <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(table)}/> */}
																	<img
																		className="w-[1rem] cursor-pointer"
																		src={Editing1}
																		alt=""
																		onClick={() =>
																			navigate("/tablereg", {
																				state: {
																					id: table.Table_id,
																					area: selectedOption.label,
																				},
																			})
																		}
																	/>
																</div>
															)}
														</div>
													))}
												</div>
											</div>
										) : selectedOption && tables.length < 1 ? (
											<div className="p-3 font-nunito">
												Table not yet registered.
											</div>
										) : (
											!selectedOption &&
											tableArea_Tables && (
												<div className="p-3 font-[500] font-nunito">
													Please select your preferred area.
												</div>
											)
										)}
									</div>
								)}
							</div>
						)}

						{/*................................................. taxes .................................................................. */}

						{taxes && <TaxGroup />}

						{/*................................................. Discount .................................................................. */}

						{discount && (
							<div className="h-full flex flex-col bg-[#fff] overflow-auto customScroll">
								<div className="w-full h-max flex p-3">
									{items.length > 0 ? (
										<div className="w-1/2 font-nunito flex justify-start items-center">
											Discount is not yet registered.
										</div>
									) : (



										<div className="w-1/2">
											<div className="w-1/2 flex border border-[#ccc] rounded-[.313rem]">
												<div className="flex justify-center items-center p-2">
													<img className="w-[1rem]" src={Search} alt="?" />
												</div>
												<input
													className="w-full pr-2 border-none"
													onChange={(e) => setSearch(e.target.value)}
													type="text"
													placeholder="Searchssaqa..."
												/>
											</div>
										</div>
									)}
									<div className="w-1/2 flex justify-end items-center font-nunito text-[1rem]">
										<button
											className="pt-[.25rem] pb-[.25rem] pl-3 pr-3 loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]"
											onClick={() => navigate("/Discount")}
										>
											Add Discount
										</button>
									</div>
								</div>


								<div className="h-full flex flex-col bg-[#fff] overflow-hidden">
									{/* {
                                        discountList.length > 0 && (
                                            <div className='p-3 flex gap-2 font-nunito text-[.95em]'>
                                                <input className='pl-2 pr-2 pt-[.25rem] pb-[.25rem]' type="text" placeholder='Discount Name' />
                                                <button className='pl-3 pr-3 pt-[.25rem] pb-[.25rem] loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]'>Search</button>
                                                <button className='pl-3 pr-3 pt-[.25rem] pb-[.25rem] border text-[#424242] bg-[#e0e0e0] rounded-[.313rem]'>Show all</button>
                                            </div>
                                        )
                                    } */}
									{discountList.length > 0 && (
										<div className="font-nunito flex flex-col text-center overflow-hidden">
											<div className="flex w-full bg-[#E5E5E5] font-[600] rounded-t-[.313rem]">
												<div className="p-3 w-1/12">
													<input
														type="checkbox"
														checked={isCheckedAllDiscount}
														onChange={(e) => handleIsCheckedAll(e, "discount")}
													/>
												</div>
												<div className="p-3 w-2/12 text-left">
													Discount Name
												</div>
												<div className="p-3 w-2/12">Disc %</div>
												<div className="p-3 w-2/12">SDate</div>
												<div className="p-3 w-2/12">EDate</div>
												<div className="p-3 w-2/12">Status</div>
												<div className="p-3 w-1/12">Action</div>
											</div>
											<div className="font-400 flex flex-col overflow-auto customScroll">
												{filterDiscount?.map((disc, index) => (
													<div className="flex" key={index}>
														<div className="p-3 w-1/12">
															<input
																type="checkbox"
																checked={checkedDiscount[index]}
																onChange={(e) =>
																	handleIsChecked(
																		index,
																		e.target.checked,
																		"discount"
																	)
																}
															/>
														</div>
														<div className="p-3 w-2/12 text-left">
															{disc.d_name}
														</div>
														<div className="p-3 w-2/12">{disc.d_Prctg}</div>
														<div className="p-3 w-2/12">
															{formatISODateToDDMMYYYY(disc.d_sDate)}
														</div>
														<div className="p-3 w-2/12">
															{formatISODateToDDMMYYYY(disc.d__eDate)}
														</div>
														{/* <div className='p-3 w-2/12'>{disc.d__eDate}</div> */}
														<div className="w-2/12 p-2 flex justify-center items-center relative">
															<input
																type="checkbox"
																id="active_inactive_checkbox"
																checked={
																	isActiveDiscount[disc.id_Discount] || false
																}
																readOnly
															/>
															<div
																className="active_inactive_div"
																onClick={() =>
																	handleIsActiveDiscount(
																		disc.id_Discount,
																		disc.d_activeAllTime
																	)
																}
															></div>
														</div>
														{checkedDiscount[index] ? (
															<div className="p-3 w-1/12 flex justify-center items-center gap-2">
																<img
																	className="w-[1rem] cursor-pointer"
																	src={remove}
																	alt=""
																	onClick={handleToDeleteDiscount}
																/>
															</div>
														) : (
															<div className="p-3 w-1/12 flex justify-center items-center gap-2">
																<img
																	className="w-[1rem] cursor-pointer"
																	src={Editing1}
																	alt=""
																	onClick={() =>
																		navigate("/Discount", {
																			state: {
																				id: disc.id_Discount,
																				discount: disc.d_name,
																			},
																		})
																	}
																/>
															</div>
														)}
													</div>
												))}
											</div>
										</div>

									)}
								</div>
							</div>
						)}

						{/*................................................. Kitchen .................................................................. */}

						{kitchens && (
							<div className="h-full flex flex-col overflow-hidden">
								<div className="w-full flex flex-row">
									<div className="w-1/2 h-max flex text-[.938em] font-[600] font-nunito rounded-t-[.313rem] bg-[#fff]">
										<div
											className={`flex justify-center items-center pl-5 pr-5 pt-3 pb-3 cursor-pointer ${KitchenTab
												? "MenuCategoryActive"
												: "MenuCategoryNotActive"
												}`}
											onClick={toKitchenTab}
										>
											Kitchen
										</div>
										<div
											className={`flex justify-center items-center pl-5 pr-5 pt-3 pb-3 cursor-pointer ${SubKitchenTab
												? "MenuCategoryActive"
												: "MenuCategoryNotActive"
												}`}
											onClick={toSubKitchenTab}
										>
											Sub Kitchen
										</div>
									</div>
									<div className="h-max flex w-1/2  justify-end items-center font-[600]">
										{KitchenTab && (
											<button
												className="pt-[.25rem] pb-[.25rem] pl-3 pr-3 loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]"
												onClick={() => navigate("/Kitchen")}
											>
												Add Kitchen
											</button>
										)}
										{SubKitchenTab && (
											<button
												className="pt-[.25rem] pb-[.25rem] pl-3 pr-3 loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]"
												onClick={() => navigate("/SubKitchen")}
											>
												Add SubKitchen
											</button>
										)}
									</div>
								</div>

								{KitchenTab && (
									<div className="h-full flex flex-col bg-[#fff] overflow-hidden">
										<div className="p-3 flex gap-2 font-nunito text-[.95em]">
											<input
												className="pl-2 pr-2 pt-[.25rem] pb-[.25rem]"
												type="text"
												onChange={(e) => setSearch(e.target.value)}
												value={search}
												placeholder="Kitchen Name"
											/>
											<button
												className="pl-3 pr-3 pt-[.25rem] pb-[.25rem] loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]"
												onClick={handleKitcheanSearch}
											>
												Search
											</button>
											<button
												className="pl-3 pr-3 pt-[.25rem] pb-[.25rem] border text-[#424242] bg-[#e0e0e0] rounded-[.313rem]"
												onClick={handleShowKitchen}
											>
												Show all
											</button>
										</div>

										{loadingKitchen.length > 0 ? (
											<div className="font-nunito flex flex-col text-center overflow-hidden">
												<div className="flex w-full bg-[#E5E5E5] font-[600] rounded-t-[.313rem]">
													<div className="p-3 w-1/12">
														<input
															type="checkbox"
															checked={isCheckedAllKitchen}
															onChange={(e) => handleIsCheckedAll(e, "kitchen")}
														/>
													</div>
													<div className="p-3 w-4/12 text-left">
														Kitchen Name
													</div>
													<div className="p-3 w-2/12">Kitchen Code</div>
													<div className="p-3 w-2/12">Status</div>
													<div className="p-3 w-3/12">Action</div>
												</div>
												<div className="font-400 flex flex-col overflow-auto customScroll">
													{loadingKitchen.map((kitchen, index) => (
														<div className="flex" key={index}>
															<div className="p-3 w-1/12">
																<input
																	type="checkbox"
																	checked={checkedKitchen[index]}
																	onChange={(e) =>
																		handleIsChecked(
																			index,
																			e.target.checked,
																			"kitchen"
																		)
																	}
																/>
															</div>
															<div className="p-3 w-4/12 text-left">
																{kitchen.KitchenName}
															</div>
															<div className="p-3 w-2/12">
																{kitchen.KitchenCode}
															</div>
															<div className="w-2/12 p-2 flex justify-center items-center relative">
																<input
																	type="checkbox"
																	id="active_inactive_checkbox"
																	checked={
																		isActiveKitchen[kitchen.Kitchen_id] || false
																	}
																	readOnly
																/>
																<div
																	className="active_inactive_div"
																	onClick={() =>
																		handleIsActiveKitchen(
																			kitchen.Kitchen_id,
																			kitchen.Kitchen_is_Active
																		)
																	}
																></div>
															</div>
															{checkedKitchen[index] ? (
																<div className="p-3 w-3/12 flex justify-center items-center gap-2">
																	<img
																		className="w-[1rem] cursor-pointer"
																		src={remove}
																		alt=""
																		onClick={handleToDeleteKitchen}
																	/>
																</div>
															) : (
																<div className="p-3 w-3/12 flex justify-center items-center gap-2">
																	{/* <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(kitchen)}/> */}
																	<img
																		className="w-[1rem] cursor-pointer"
																		src={Editing1}
																		alt=""
																		onClick={() =>
																			navigate("/Kitchen", {
																				state: {
																					id: kitchen.Kitchen_id,
																					kitchen: kitchen.KitchenName,
																				},
																			})
																		}
																	/>
																</div>
															)}
															{/* <div className='p-3 w-3/12 flex justify-center items-center gap-2'>
                                                                    <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(kitchen)}/>
                                                                    <img className='w-[1rem] cursor-pointer' src={Editing1} alt="" onClick={() => navigate('/Kitchen',{
                                                                        state : {
                                                                            id: kitchen.Kitchen_id,
                                                                            kitchen: kitchen.KitchenName
                                                                        }
                                                                    })}/>
                                                                </div> */}
														</div>
													))}
												</div>
											</div>
										) : (
											<div className="p-3 font-nunito">
												Kitchen not yet registered.
											</div>
										)}
									</div>
								)}

								{SubKitchenTab && (
									<div className="h-full flex flex-col bg-[#fff] overflow-hidden">
										<div className="p-3 flex gap-2 font-nunito text-[.95em]">
											<input
												className="pl-2 pr-2 pt-[.25rem] pb-[.25rem]"
												type="text"
												onChange={(e) => setSearch(e.target.value)}
												value={search}
												placeholder="Sub Kitchen Name"
											/>
											<button
												className="pl-3 pr-3 pt-[.25rem] pb-[.25rem] loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem]"
												onClick={handleSubKitcheanSearch}
											>
												Search
											</button>
											<button
												className="pl-3 pr-3 pt-[.25rem] pb-[.25rem] border text-[#424242] bg-[#e0e0e0] rounded-[.313rem]"
												onClick={handleShowSubKitchen}
											>
												Show all
											</button>
										</div>

										{loadingSubKitchen.length > 0 ? (
											<div className="font-nunito flex flex-col text-center overflow-hidden">
												<div className="flex w-full bg-[#E5E5E5] font-[600] rounded-t-[.313rem] sticky top-0 z-[1111]">
													<div className="p-3 w-1/12">
														<input
															type="checkbox"
															checked={isCheckedAllSubKitchen}
															onChange={(e) =>
																handleIsCheckedAll(e, "subKitchen")
															}
														/>
													</div>
													<div className="p-3 w-4/12 text-left">
														Sub Kitchen Name
													</div>
													<div className="p-3 w-2/12">Kitchen Code</div>
													<div className="p-3 w-2/12">Status</div>
													<div className="p-3 w-3/12">Action</div>
												</div>
												<div className="font-400 flex flex-col overflow-auto customScroll">
													{loadingSubKitchen.map((kitchen, index) => (
														<div className="flex" key={index}>
															<div className="p-3 w-1/12">
																<input
																	type="checkbox"
																	checked={checkedSubKitchen[index]}
																	onChange={(e) =>
																		handleIsChecked(
																			index,
																			e.target.checked,
																			"subKitchen"
																		)
																	}
																/>
															</div>
															<div className="p-3 w-4/12 text-left">
																{kitchen.SubKitchenName}
															</div>
															<div className="p-3 w-2/12">
																{kitchen.KitchenCode}
															</div>
															<div className="w-2/12 p-2 flex justify-center items-center relative">
																<input
																	type="checkbox"
																	id="active_inactive_checkbox"
																	checked={
																		isActiveSubKitchen[
																		kitchen.Sub_Kitchen_id
																		] || false
																	}
																	readOnly
																/>
																<div
																	className="active_inactive_div"
																	onClick={() =>
																		handleIsActiveSubKitchen(
																			kitchen.Sub_Kitchen_id,
																			kitchen.Sub_Kitchen_is_Active
																		)
																	}
																></div>
															</div>
															{checkedSubKitchen[index] ? (
																<div className="p-3 w-3/12 flex justify-center items-center gap-2">
																	<img
																		className="w-[1rem] cursor-pointer"
																		src={remove}
																		alt=""
																		onClick={handleToDeleteSubKitchen}
																	/>
																</div>
															) : (
																<div className="p-3 w-3/12 flex justify-center items-center gap-2">
																	{/* <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(item)}/> */}
																	<img
																		className="w-[1rem] cursor-pointer"
																		src={Editing1}
																		alt=""
																		onClick={() =>
																			navigate("/SubKitchen", {
																				state: {
																					id: kitchen.Sub_Kitchen_id,
																					kitchen: kitchen.SubKitchenName,
																				},
																			})
																		}
																	/>
																</div>
															)}
														</div>
													))}
												</div>
											</div>
										) : (
											<div className="p-3 font-nunito">
												Sub Kitchen not yet registered.
											</div>
										)}
									</div>
								)}
							</div>
						)}
					</div>
					{viewDetails && (
						<div
							className={`absolute right-0 h-full w-max pl-3 pr-0 pt-3 pb-3 flex justify-center items-center bg-transparent gap-2 ${isExiting ? "slide-out" : "slide-in"
								}`}
						>
							<div
								className="h-8 w-max flex justify-center items-center pl-1 pr-1 pt-2 pb-2 bg-[#464545] cursor-pointer transition-all duration-300 hover:h-16"
								onClick={handleClose}
							>
								<img className="w-[.5rem] h-[1rem]" src={right} alt="" />
							</div>
							<div className="w-[30rem] rounded-l-lg shadow-2xl border-l-2 border-t bg-[#f8f8f8] h-full">
								{/* {viewUserDetails} */}
							</div>
						</div>
					)}
				</div>
			</div>
			{/* {addVarient && (
                <div className='AddVarientModel'>
                    <div className='AddVarientModelDiv' ref={parentRef}>
                        <AddVarientModel 
                            onClose={() => {
                                setAddVarient(false)
                            }}
                            parentRef={parentRef}/>
                    </div>
                </div>
            )} */}
		</div>
	);
}

export default BaseMenuRegDesktop;
